export const CHANGE_PASSWORD_STATE_KEY = 'changePassword'
export const FORM_CHANGE_PASSWORD_NAME = 'formChangePassword'

export const CONTENT_LOAD = 'Casino/ChangePassword/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/ChangePassword/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/ChangePassword/LOAD_ERROR'
